import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNull from "lodash/isNull";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";

/* eslint-disable camelcase */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useUrlParams, useIsMounted, Input, Dropdown, useUser } from 'components';
import { BORROWERS_SEARCH_TYPE, borrowerSearchTypesName, borrowerSearchTypesNameSelect, borrowerCreditsCountSelect, hasActiveCreditsSelect, hasLatePaymentsSelect } from 'enums';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var filterField = {
  flex: '1 1 180px',
  maxWidth: 240,
  minWidth: 140
};
var filterFieldWide = {
  flex: '2 1 280px',
  maxWidth: 400,
  minWidth: 200
};

var BorrowersTableHeader = function BorrowersTableHeader(_ref) {
  var getData = _ref.getData;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var searchBy = urlQueryParams.searchBy,
      search = urlQueryParams.search,
      min_count_credits = urlQueryParams.min_count_credits,
      max_count_credits = urlQueryParams.max_count_credits,
      has_active_credits = urlQueryParams.has_active_credits,
      has_late_payments = urlQueryParams.has_late_payments,
      employee = urlQueryParams.employee,
      office = urlQueryParams.office;
  var queryParams = useRef(urlQueryParams);
  var isMounted = useIsMounted();
  useEffect(function () {
    if (isMounted.current) {
      var _queryParams$current$, _queryParams$current;

      queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
        searchBy: (_queryParams$current$ = (_queryParams$current = queryParams.current) === null || _queryParams$current === void 0 ? void 0 : _queryParams$current.searchBy) !== null && _queryParams$current$ !== void 0 ? _queryParams$current$ : BORROWERS_SEARCH_TYPE.id_number
      });
      getData(queryParams.current);
    }
  }, []);

  var handleSearchTypeChange = function handleSearchTypeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      searchBy: value
    });
  };

  var handleSearchChange = function handleSearchChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      search: value
    });
    _isNull(value) && getData(queryParams.current);
  };

  var handleCreditsCountChange = function handleCreditsCountChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      min_count_credits: value === null || value === void 0 ? void 0 : value.min_count_credits,
      max_count_credits: value === null || value === void 0 ? void 0 : value.max_count_credits
    });
    getData(queryParams.current);
  };

  var handleActiveCreditsChange = function handleActiveCreditsChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      has_active_credits: value
    });
    getData(queryParams.current);
  };

  var handleLatePaymentChange = function handleLatePaymentChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      has_late_payments: value
    });
    getData(queryParams.current);
  };

  var handleEmployeeChange = function handleEmployeeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      employee: value
    });
    getData(queryParams.current);
  };

  var handleOfficeChange = function handleOfficeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: value
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    noClear: true,
    placeholder: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435 \u043F\u043E",
    value: borrowerSearchTypesName[searchBy],
    options: borrowerSearchTypesNameSelect,
    onChange: handleSearchTypeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    style: filterFieldWide
  }, ___EmotionJSX(Input, {
    small: true,
    clear: true,
    placeholder: "\u0418\u043C\u0435, \u0415\u0413\u041D \u0438 \u0422\u0435\u043B.",
    onChange: handleSearchChange,
    onKeyDown: function onKeyDown(e) {
      return e.keyCode === 13 && getData(queryParams.current);
    },
    value: search
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u0411\u0440\u043E\u0439 \u041A\u0440\u0435\u0434\u0438\u0442\u0438",
    value: borrowerCreditsCountSelect === null || borrowerCreditsCountSelect === void 0 ? void 0 : borrowerCreditsCountSelect.find(function (el) {
      var _el$value, _el$value2;

      return (el === null || el === void 0 ? void 0 : (_el$value = el.value) === null || _el$value === void 0 ? void 0 : _el$value.min_count_credits) === min_count_credits && (el === null || el === void 0 ? void 0 : (_el$value2 = el.value) === null || _el$value2 === void 0 ? void 0 : _el$value2.max_count_credits) === max_count_credits;
    }),
    options: borrowerCreditsCountSelect,
    onChange: handleCreditsCountChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438",
    value: has_active_credits,
    options: hasActiveCreditsSelect,
    onChange: handleActiveCreditsChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0438\u0435",
    value: has_late_payments,
    options: hasLatePaymentsSelect,
    onChange: handleLatePaymentChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.employees) && ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B",
    displayKey: "name",
    uniqueKey: "id",
    value: employee,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.employees,
    onChange: handleEmployeeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices) && ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041E\u0444\u0438\u0441",
    displayKey: "name",
    uniqueKey: "id",
    value: office,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices,
    onChange: handleOfficeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })));
};

BorrowersTableHeader.propTypes = {
  getData: PropTypes.func
};
export default BorrowersTableHeader;